<template>
  <div class="page payment-page">
    <div class="payment-hero">
      <div class="section-kicker">WECHAT PAY</div>
      <h1>微信支付</h1>
      <p>订单由后台创建，支付结果以微信支付服务器异步通知为准。</p>
    </div>
    <div class="card pay-card">
      <h3>网络机顶盒服务</h3>
      <p class="muted">实际金额与订单标题由后台系统配置统一管理。</p>
      <button class="btn" :disabled="paying" @click="pay">{{ paying ? '正在创建订单…' : '微信支付' }}</button>
    </div>
    <div class="card">
      <h3>支付记录</h3>
      <div v-if="!orders.length" class="muted">暂无支付记录</div>
      <div class="order" v-for="x in orders" :key="x.order_no">
        <div><b>{{ x.body }}</b><span>{{ x.order_no }}</span></div>
        <div class="right"><b>¥{{ (x.amount_fen/100).toFixed(2) }}</b><span>{{ statusText(x.status) }}</span></div>
      </div>
    </div>
  </div>
</template>
<script>
import { api, getUserId, isWechat } from '../api'
export default {
  data:()=>({paying:false,orders:[],applicationId:null}),
  created(){this.applicationId=this.$route.query.applicationId||localStorage.getItem('pendingApplicationId');this.load()},
  methods:{
    async load(){try{await api.post('/h5/pay/reconcile')}catch(e){}this.orders=(await api.get('/h5/pay/orders')).data.data||[];const paid=this.orders.find(x=>x.status==='PAID'&&String(x.application_id)===String(this.applicationId));if(paid&&this.$route.path==='/payment'){this.$router.replace('/agreement?applicationId='+this.applicationId);return}if(this.orders.some(x=>x.status==='PAID')){const home=(await api.get('/h5/home',{params:{userId:getUserId()}})).data.data;if(home.device&&home.device.sn)localStorage.setItem('deviceSn',home.device.sn)}},
    async pay(){
      if(!isWechat()){alert('请在微信内打开页面后支付');return}
      this.paying=true
      try{
        const p=(await api.post('/h5/pay/create',{},{params:{applicationId:this.applicationId}})).data.data
        const invoke=()=>window.WeixinJSBridge.invoke('getBrandWCPayRequest',p,async res=>{if(res.err_msg==='get_brand_wcpay_request:ok'){alert('支付已完成，正在与微信核对结果');await this.confirmPaid(p.orderNo)}else{this.paying=false;alert('支付未完成：'+res.err_msg)}})
        if(typeof window.WeixinJSBridge==='undefined') document.addEventListener('WeixinJSBridgeReady',invoke,false); else invoke()
      }catch(e){this.paying=false;alert((e.response&&e.response.data&&e.response.data.message)||e.message||'支付下单失败')}
    },
    async confirmPaid(orderNo){let message='微信正在处理支付结果，请稍后刷新支付记录';for(let i=0;i<12;i++){try{const r=(await api.post('/h5/pay/reconcile',{},{params:{orderNo}})).data.data||{};message=r.message||message;if(r.status==='PAID'||r.reconciled){this.paying=false;await this.load();const applicationId=r.applicationId||this.applicationId;alert('支付确认成功，请继续签署正式协议');this.$router.replace('/agreement?applicationId='+applicationId);return}}catch(e){message=(e.response&&e.response.data&&e.response.data.message)||message}await new Promise(resolve=>setTimeout(resolve,2000))}this.paying=false;await this.load();alert(message)},
    statusText(s){return ({CREATED:'已创建',PREPAY:'待支付',PAID:'支付成功',CLOSED:'已关闭'})[s]||s}
  }
}
</script>
<style scoped>
.payment-hero{background:linear-gradient(135deg,#123d30,#12ae69);color:#fff;border-radius:26px;padding:30px;margin-bottom:18px}.payment-hero h1{margin:6px 0}.payment-hero p{margin:0;color:rgba(255,255,255,.8)}.pay-card{text-align:center;padding:30px}.pay-card .btn{min-width:180px;margin-top:12px}.order{display:flex;justify-content:space-between;gap:16px;padding:15px 0;border-bottom:1px solid #edf3ef}.order span{display:block;color:#84918c;font-size:12px;margin-top:4px}.right{text-align:right}.right b{color:#0c9a5e}@media(max-width:768px){.payment-hero{padding:20px;border-radius:20px}.order{font-size:14px}}
</style>
